function bringImageToFocus(imgId, newSrc) {
  document.getElementById(imgId).src = newSrc;
}

function showPopup(popup, overlay) {
  if( window.innerWidth<1024) return;
  document.getElementById(popup).style.display = "flex";
  document.getElementById(overlay).style.display = "flex";
}

function closePopup(popup, overlay) {
  document.getElementById(popup).style.display = "none";
  document.getElementById(overlay).style.display = "none";
}

function increaseCount(maxQty) {
  let currentCount = null;
  currentCount = parseInt(document.getElementById("quantity").value);
  if (!currentCount) currentCount = 0;

  if (currentCount < maxQty) {
    document.getElementById("quantity").value = currentCount + 1;
  }
}

function decreaseCount() {
  let currentCount = null;
  currentCount = parseInt(document.getElementById("quantity").value);
  if (!currentCount) {
    currentCount = 0;
  } else if (currentCount > 0) {
    document.getElementById("quantity").value = currentCount - 1;
  }
}
